"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBreadcrumbs = exports.resetBreadcrumbs = exports.captureBreadcrumb = void 0;
var tslib_1 = require("tslib");
var list = [];
function captureBreadcrumb(breadcrumb) {
    list.push(tslib_1.__assign(tslib_1.__assign({}, breadcrumb), { time: new Date() }));
}
exports.captureBreadcrumb = captureBreadcrumb;
function resetBreadcrumbs() {
    list = [];
}
exports.resetBreadcrumbs = resetBreadcrumbs;
function getBreadcrumbs() {
    return tslib_1.__spreadArrays(list);
}
exports.getBreadcrumbs = getBreadcrumbs;
//# sourceMappingURL=breadcrumbs-logger.js.map